import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 筛选项hooks
 * @author alfielv
 */
import _ from 'lodash';
import { useMemo } from 'react';
; // filter Map,  key => item 映射

var getFiltersMap = function getFiltersMap(controls) {
  // 全量filter 数组
  var filterArray = function () {
    if (_.isArray(controls)) {
      return controls;
    }

    if (!_.isPlainObject(controls)) {
      return [];
    }

    var retList = [];

    var deepMap = function deepMap(list) {
      return _.map(list, function (item) {
        var filters = _.get(item, 'filters');

        var list = _.get(item, 'list');

        if (filters) {
          retList.push.apply(retList, _toConsumableArray(filters));
        } else if (list) {
          deepMap(list);
        }
      });
    };

    deepMap(_.values(controls));
    return retList;
  }();

  return _.reduce(filterArray, function (prev, cur) {
    var key = cur.key || cur.name;
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, cur));
  }, {});
};

export default (function (props) {
  var filterConfig = props.filterConfig;

  var _ref = filterConfig || {},
      controls = _ref.controls,
      customConfigure = _ref.customConfigure; // 全量filter映射


  var filterMap = useMemo(function () {
    return controls ? getFiltersMap(controls) : {};
  }, [controls]);

  var _ref2 = function () {
    // 业务业务侧自定义的配置
    if (customConfigure && !_.isEmpty(customConfigure)) {
      return {
        customFilterComponent: customConfigure.customFilterComponent,
        customFiltersLoading: _.get(filterConfig, 'customConfigure.loading', true)
      };
    } // 取全量筛选项


    // 取全量筛选项
    return {
      customFilterComponent: null,
      customFiltersLoading: false
    };
  }(),
      customFilterComponent = _ref2.customFilterComponent,
      customFiltersLoading = _ref2.customFiltersLoading;

  return {
    customFilterComponent: customFilterComponent,
    // 自定义筛选项触发组件
    customFiltersLoaded: !customFiltersLoading,
    // 自定义配置项加载完成
    filterMap: filterMap // 全量filter映射

  };
});